import React from 'react';
import PropTypes from 'prop-types';
import { emit } from 'helpers/global-events';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import Button, { btnThemes } from 'components/button';
import Notification from 'components/notification';
import Row, { Col } from 'components/row';

@apiDecorator
export default class BanPosts extends React.PureComponent {
  static propTypes = {
    topicItems: PropTypes.arrayOf(PropTypes.shape({})),
    onResetSelection: PropTypes.func
  };

  // Action for closing modal window
  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  onBan =()=> this.setBan(true);

  permitPost =()=> this.setBan(false);

  setBan =(ban)=> {
    const { topicItems } = this.props;

    this.api.post('action/forum/actions-ban-posts-topics/ban-posts', {
      postData: {
        topics: topicItems,
        ban
      }
    })
      .then(()=>this.afterSetBan(topicItems, ban))
      .catch(error => reportError(error));
  }

  // Call after success save topics data.
  afterSetBan(topicItems, ban) {
    Notification.success(
      ban ? 'Всем Новым пользователям запрещено постить!' : 'Всем Новым пользователям разрешено постить!'
    );

    // Close modal window.
    if (this.context && this.context.close) this.context.close();

    this.props.onResetSelection(false, topicItems);

    // Update topics.
    emit('updateClubTopics');
  }

  render() {
    return (
      <Row>
        <Col allPr={20} allPb={20}>
          <Button
            onClick={this.onBan}
            label='Запретить постить'
            title='Запретить постить'
            theme={btnThemes.sky}
            big
          />
        </Col>
        <Col allPr={0} allPb={20} allFlex allJustifyCFlexEnd>
          <Button
            onClick={this.permitPost}
            label='Разрешить постить'
            title='Разрешить постить'
            theme={btnThemes.light}
            big
          />
        </Col>
      </Row>
    );
  }
}
